module.exports = __webpack_public_path__ + "img/922c8de.png";